module.exports = __webpack_public_path__ + "static/img/4.志工服務活動-2.1acc22b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities/4.志工服務活動-2.jpg
// module id = HyaS
// module chunks = 98